import { Avatar, Box, HStack, StackProps, Text } from '@chakra-ui/react';

type Props = StackProps & {
  icon?: React.ReactElement,
  label: string,
  value: string
}

export default function Stat({ label, value, icon, ...props }: Props) {
  return (
    <HStack 
      spacing="13px"
      pb="20px"
      {...props}
    >
      <Avatar 
        bgColor="white"
        borderColor="#E2E4E9"
        borderWidth="1px"
        icon={icon} 
      />
      <Box>
        <Text 
          as="strong"
          color="#868C98"
          letterSpacing="0.22px"
          textTransform="uppercase"
          fontWeight={500}
          fontSize="11px"
        >
          {label}
        </Text>
        <br />
        <Text 
          as="span"
          color="#0a0d14cc"
          letterSpacing="-0.176px"
          fontSize="16px"
          fontWeight={500}
        >
          {value}
        </Text>
      </Box>
    </HStack>
  )
}
